import * as editor from "./editor";
import * as selectTemplate from "./select-template";
import * as templateLists from "./template-lists";

export const reducer = () => ({
  [templateLists.MODULE]: templateLists.reducer,
  [selectTemplate.MODULE]: selectTemplate.reducer,
  [editor.MODULE]: editor.reducer,
});

export default {};
